import { BTN_TXT } from 'constants/txt'
import { Button, BUTTON_TYPES } from 'components/Button'
import { useRFPCreateSurveyContext } from 'features/RFP/RFPSurvey/CreateSurvey/Providers/RFPCreateSurveyContextProvider'
import { useRFPDetailsPopupContext } from '../../RFPDetails/Providers/RFPDetailsPopupProvider'

export const CreateSurveyButton = () => {
  const rfpCreateSurveyContext = useRFPCreateSurveyContext()

  const { createSurveyPopup } = useRFPDetailsPopupContext()
  const { canCreateOrEditSurvey } = rfpCreateSurveyContext.state

  return canCreateOrEditSurvey ? (
    <div className="create-survey__actions">
      <Button
        type={BUTTON_TYPES.PRIMARY}
        onClick={createSurveyPopup.actions.open}
        upperCase
      >
        {BTN_TXT.CREATE_SURVEY}
      </Button>
    </div>
  ) : null
}
